import React, { useState, useEffect } from "react";
import ButtonAndMoney from "src/common/form/buttonAndMoney";
import { getOrientation } from "src/modules/helpers";

function ValorInput({
  onChange,
  title,
  minValue = 0,
  value: propsValue,
  maxValue,
}) {
  const isFixedValue = minValue === maxValue;
  const [value, setValue] = useState(minValue === 0 ? 0 : minValue * 100);
  const orientation = getOrientation();

  useEffect(() => {
    if (!propsValue) {
      setValue(minValue === 0 ? 0 : minValue * 100);
    } else if (minValue === 0) {
      setValue(propsValue);
    } else {
      setValue(minValue < propsValue ? propsValue : minValue * 100);
    }
  }, [minValue, propsValue]);

  function incrementValue(rawValue) {
    // const sum =
    //   rawValue > 0
    //     ? value + rawValue
    //     : rawValue + value < minValue * 100
    //     ? minValue * 100
    //     : rawValue + value;
    const sum = correctValue(rawValue + value);

    const newValue = sum <= 0 ? 0 : sum;

    setValue(newValue);
    onChange(newValue);
  }

  function handleChange(rawValue) {
    setValue(rawValue);
    onChange(rawValue);
  }

  function correctValue(value) {
    let newValue = value;

    if (maxValue * 100 && value > maxValue * 100) {
      newValue = maxValue * 100;
    } else if (value < minValue * 100) {
      newValue = minValue * 100;
    }

    return newValue;
  }

  return (
    <React.Fragment>
      <label>{title ? title : "Valor"}</label>
      <div className="div-center space-between">
        <ButtonAndMoney
          id="numValor"
          orientation={orientation}
          onChange={handleChange}
          value={value}
          onIncrement={incrementValue}
          increment="50"
          colSize="12"
          disabled={isFixedValue}
          onBlur={() => {
            const newValue = correctValue(value);
            setValue(newValue);
            onChange(newValue);
          }}
        />
      </div>
      {!isFixedValue && (
        <div className="div-center space-between" style={{ marginTop: "10px" }}>
          <div>
            <button
              type="button"
              className={`btn btn-primary alternative-button`}
              onClick={() => incrementValue(10)}
            >
              + 0,10
            </button>
            <button
              type="button"
              className={`btn btn-primary alternative-button`}
              onClick={() => incrementValue(100)}
            >
              + 1,00
            </button>
            <button
              type="button"
              className={`btn btn-primary alternative-button`}
              onClick={() => incrementValue(200)}
            >
              + 2,00
            </button>
            <button
              type="button"
              className={`btn btn-primary alternative-button`}
              onClick={() => incrementValue(500)}
            >
              + 5,00
            </button>
          </div>
        </div>
      )}
    </React.Fragment>
  );
}

export default ValorInput;



// WEBPACK FOOTER //
// ./src/newDesign/components/valor-input.jsx